import { CALL_API } from 'redux-api-middleware';
import * as fromRootReducer from '../../modules/root-reducer';

// Adds idToken to API requests that have addAuth:true
// Insert before redux-api-middleware in chain
export const middleware = ({ getIdToken }) => store => next => action => {
    const callAPI = action[CALL_API];
    if (callAPI !== undefined) {

        if (callAPI.options && callAPI.options.addAuth === true) {
            const state = store.getState();
            callAPI.headers = Object.assign({}, callAPI.headers, {
                Authorization: getIdToken(state) || '',
            });
        }
    }

    return next(action);
};

export default middleware(fromRootReducer);
